import { css } from 'styled-components';
import { CFBaseContainerHelpers } from './styles';
export const CFBaseContainerStyles = {
    Root: css `
    box-sizing: border-box;
    display: flex;
    flex-direction: ${CFBaseContainerHelpers.orientation};
    gap: ${CFBaseContainerHelpers.gap}px;
    border-radius: ${CFBaseContainerHelpers.borderRadius}px;
    ${CFBaseContainerHelpers.border};
    ${CFBaseContainerHelpers.shadow};
    ${CFBaseContainerHelpers.backgroundColor};
    ${CFBaseContainerHelpers.backgroundImage};
    ${CFBaseContainerHelpers.flex};
    ${CFBaseContainerHelpers.height};
    ${CFBaseContainerHelpers.padding};
    ${CFBaseContainerHelpers.width};
  `,
    RootAlignment: css `
    ${CFBaseContainerHelpers.align};
  `,
};
